import React, {useState}  from "react";
import {
    IonToolbar,
    IonMenu,
    IonList,
  } from "@ionic/react";
import { useRecoilValue } from "recoil";
import { sideBarActiveMenu } from "../../../store/atoms/sideBarAtoms"
import { useRecoilState, } from "recoil";
import { useHistory } from "react-router-dom";
import SupportModal from "../../../components/modals/supportModal"

import {handleNewDeliveryMenuItemOnClick, handleDeliveriesMenuItemOnClick, handleDashboardMenuItemOnClick} from "../handler"


const SideBarMobileViewComponent = () => {
  const history = useHistory();
  
  const [sideBarMenuState, setSideBarMenuState] = useRecoilState(sideBarActiveMenu);
  const [openSupportModal, setOpenSupportModal] = useState(false)
  
  return (
    <>
      <IonMenu content-id="main-content">
        <IonToolbar></IonToolbar>
        <IonList className="sidebar-list mobile-view">
          <div className="logout-card">
            <ion-avatar slot="start">
              <img src="img/ryde-profile.png" />
            </ion-avatar>
            <ion-label>
              <h2>RYDE Technologies Pte Ltd</h2>
              <p>Lokesh</p>
            </ion-label>
          </div>

          <ion-item lines="none" onClick={()=>{handleNewDeliveryMenuItemOnClick(setSideBarMenuState,history)}}>
            <div className={sideBarMenuState.newDeliveryItem === true ? "sidemenu-list active" : "sidemenu-list"}>
              <img src="img/new-delivery.svg" />
              <ion-label>New Delivery</ion-label>
            </div>
          </ion-item>
          <ion-item lines="none" onClick={()=>{handleDashboardMenuItemOnClick(setSideBarMenuState,history)}}>
            <div className={sideBarMenuState.dashboardItem === true? "sidemenu-list active" : "sidemenu-list"}>
              <img src="img/dashboard.svg" />
              <ion-label>Dashboard</ion-label>
            </div>
          </ion-item>
          <ion-item lines="none" onClick={()=>{handleDeliveriesMenuItemOnClick(setSideBarMenuState,history)}}>
            <div className={sideBarMenuState.deliveriesItem === true ? "sidemenu-list active" : "sidemenu-list"}>
              <img src="img/all-deliveries.svg" />
              <ion-label>All Deliveries</ion-label>
            </div>
          </ion-item>
          <ion-item lines="none" onClick={() => { setOpenSupportModal(true);}}>
            <div className="sidemenu-list">
              <img src="img/support.svg" />
              <ion-label>Support</ion-label>
            </div>
          </ion-item>
          <a href="/login" className="mob-logout">
            Logout
          </a>
        </IonList>
      </IonMenu>
      <SupportModal isOpen={openSupportModal} setIsOpen={setOpenSupportModal}/>
    </>
  );
};

export default SideBarMobileViewComponent;